import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import './MemberManagement.css';

const MemberManagement = () => {
  const dummyMembers = [
    { id: 1, name: 'John Doe', room: 'A-101', email: 'john@example.com', status: 'Active' },
    { id: 2, name: 'Jane Smith', room: 'A-102', email: 'jane@example.com', status: 'Active' },
    { id: 3, name: 'Bob Wilson', room: 'B-201', email: 'bob@example.com', status: 'Pending' },
  ];

  return (
    <DashboardLayout>
      <div className="member-management">
        <div className="header">
          <h1>Member Management</h1>
          <button className="add-member-btn">Add New Member</button>
        </div>

        <div className="members-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Room</th>
                <th>Email</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {dummyMembers.map(member => (
                <tr key={member.id}>
                  <td>{member.name}</td>
                  <td>{member.room}</td>
                  <td>{member.email}</td>
                  <td>
                    <span className={`status ${member.status.toLowerCase()}`}>
                      {member.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="edit-btn">Edit</button>
                      <button className="delete-btn">Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default MemberManagement; 